import React, { useCallback, useEffect, useRef, useState } from 'react';
import Modal from './Modal';
import Button from './Button';

/** Promise-based confirmation, retaining the caller's action and message. */
export default function useConfirm() {
  const [message, setMessage] = useState(null);
  const pending = useRef(null);
  const settle = useCallback(value => {
    pending.current?.(value);
    pending.current = null;
    setMessage(null);
  }, []);
  useEffect(() => () => { pending.current?.(false); }, []);
  const confirm = useCallback(next => new Promise(resolve => {
    pending.current?.(false);
    pending.current = resolve;
    setMessage(next);
  }), []);
  const dialog = <Modal open={message !== null} onClose={() => settle(false)} title="Confirm" layerClassName="z-[110]" footer={<><Button variant="secondary" onClick={() => settle(false)}>Cancel</Button><Button onClick={() => settle(true)}>Continue</Button></>}>{message}</Modal>;
  return [confirm, dialog];
}
